import { createSlice } from '@reduxjs/toolkit';

import { UserFeedbackState } from '../../types';

const initialState = null as UserFeedbackState;

const userFeedbackSlice = createSlice({
    name: 'userFeedback',
    initialState,
    reducers: {},
});

export const userFeedbackReducer = userFeedbackSlice.reducer;
